// extracted by mini-css-extract-plugin
export default {"container":"styles_container__V-TEY","container--alert":"styles_container--alert__BBdtL"};